module.exports = __webpack_public_path__ + "img/unitati_masura.ceea3eb9.svg";